import React from "react";
import "./App.scss";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./app/routes/routes";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { esES } from "@mui/x-date-pickers/locales";

import darkTheme from "./assets/styles/darkTheme";

const cache = createCache({
  key: "css",
  prepend: true,
});

function App() {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      localeText={
        esES.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      <CacheProvider value={cache}>
        <ThemeProvider theme={darkTheme}>
          <CssBaseline />
          <div className="App">
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </div>
        </ThemeProvider>
      </CacheProvider>
    </LocalizationProvider>
  );
}

export default App;
